module.exports = __webpack_public_path__ + "img/sel_Hong Kong.2114640e.jpg";